import { render, staticRenderFns } from "./mb-fotter.vue?vue&type=template&id=63ced82a&scoped=true&"
import script from "./mb-fotter.vue?vue&type=script&lang=js&"
export * from "./mb-fotter.vue?vue&type=script&lang=js&"
import style0 from "./mb-fotter.vue?vue&type=style&index=0&id=63ced82a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ced82a",
  null
  
)

export default component.exports